import axios from "@/libs/api.request";

// 获取超时未派列表
export const getList = params => {
  return axios.request({
    url: "/report/tracker/tt",
    method: "get",
    params
  });
};
